module.exports = __webpack_public_path__ + "static/media/access_228.d52874a6.ico";